import { formatExistingStatusCheck } from 'utils/team-external-integrations/team-external-integrations-util'

import type {
  DynatraceStatusCheckCreateRequest,
  ServiceStatusCheckFromStatusCheck,
  StatusCheck,
  StatusCheckCreateRequest
} from 'types/api/status-checks/status-check'

export enum StatusCheckFormStep {
  Authentication = 'Authentication',
  StatusCheck = 'Connect Monitor or Alert'
}

// Type guarding to first check which type of statusCheck was passed in
export function getIsStatusCheck(
  statusCheck: StatusCheck | ServiceStatusCheckFromStatusCheck
): statusCheck is StatusCheck {
  // Chose a field that is required and exists only in StatusCheck and not ServiceStatusCheckFromStatusCheck
  // We can't choose `identifier` because that gets overwritten in the cloning flow
  return 'createdAt' in statusCheck
}

export function getFormattedStatusCheck(
  statusCheckFromLocationState:
    | StatusCheck
    | ServiceStatusCheckFromStatusCheck
    | undefined
) {
  if (!statusCheckFromLocationState) {
    return
  }

  return getIsStatusCheck(statusCheckFromLocationState)
    ? formatExistingStatusCheck(statusCheckFromLocationState)
    : statusCheckFromLocationState
}

export function getIsDynatraceIntelligentHealthCheckRequest(
  request: StatusCheckCreateRequest | DynatraceStatusCheckCreateRequest
): request is DynatraceStatusCheckCreateRequest {
  return 'k8sQuery' in request || 'entityId' in request
}
